import { store } from '@sonifi/wb-core/store/store';
import { initGuestRequestSettings } from '../Settings/services/grSettings.service';

export async function loaderGrSettings({ params }) {
  const { groupId } = params;
  await store.dispatch(initGuestRequestSettings(parseInt(groupId)));
  return {};
}
